import { render } from "./ui.cattle.io.navlink.vue?vue&type=template&id=3f485a32"
import script from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js"
export * from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__